import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 volumes', '5 bonus', '240 pages', '3 groupes'];
const reassurances = ['Téléchargement numérique immédiat', 'PDF à imprimer', 'Garantie satisfaction 7 jours'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15fghwkon130x">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbadk20ehvw3" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2yb8knjw960">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t252je5179l8">
          Vos séances d'aquagym peuvent être <em className="text-red-700" data-id="element-118" data-mp="223cyvqnzm0co">prêtes dès aujourd'hui.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="2219yqdt4equ8">
          Au lieu de chercher des exercices, d'écrire chaque séance vous-même et de passer vos dimanches
          soir à préparer, vous avez un pack d'aquagym organisé pour toute la saison. Plus de temps pour
          ce qui compte vraiment :
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x2que7kmw9lb">
          Vos participants. Votre groupe. Votre vie en dehors de la piscine.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="1658i6qfxtaaf">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b1yxvcnty3vb">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fujl1vc8dipv">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1ktw8ah70krsz"><span className="sr-only" data-id="element-125" data-mp="1kv7cgi4dg1km">Au lieu de </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1pqmrhde483im">Paiement unique – sans abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1tropxs07kbjj">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="3qvqj5u1o50ld" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3lvudzrh8j348">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3imsc96fkpa6">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3uwitkqma1bj8" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}